import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router'
import Settings from './Settings';
import Auth from './Auth';
import Calendario from './Calendario';

import Global from './Global';
import Modelo from './Modelo';
import Equipamento from './Equipamento';
import Cliente from './Cliente';
import LocalControlado from './LocalControlado';
import PontoAcesso from './PontoAcesso';
import Perfil from './Perfil';
import PerfilPortal from './PerfilPortal';
import UsuarioPlataforma from './UsuarioPlataforma';
import UsuarioPortal from './UsuarioPortal';
import AcessoPessoa from './AcessoPessoa';
import AcessoPerfil from './AcessoPerfil';
import AcessoGenero from './AcessoGenero';
import AcessoIdade from './AcessoIdade';
import AcessoPeriodo from './AcessoPeriodo';
import AcessoFull from './AcessoFull';
import AcessoBloqueio from './AcessoBloqueio';
import Localidade from './Localidade';
import VinculoPessoa from './VinculoPessoa';
import Inicio from './Inicio';
import Unidade from './Unidade';
import Categoria from './Categoria';
import Titularidade from './Titularidade';
import Ambiente from './Ambiente';
import PortariaInicio from './PortariaInicio';
import Portaria from './Portaria';
import Escola from './Escola';
import Aluno from './Aluno';
import Curso from './Curso';
import Serie from './Serie';
import Disciplina from './Disciplina';
import Turma from './Turma';
import Matricula from './Matricula';
import Rematricula from './Rematricula';
import AnoLetivo from './AnoLetivo';
import SequenciaEnturmacao from './SequenciaEnturmacao';
import SeriesEscola from './SeriesEscolaReducer';
import ComponentesSerie from './ComponentesSerie';
import AreaConhecimento from './AreaConhecimento';
import RegrasAvaliacao from './RegrasAvaliacaoReducer'
import Notificacao from './Notificacao';
import Enquetes from './Enquetes';
import RecuperarSenhaApp from './RecuperarSenhaApp';
import NotasFaltas from './NotasFaltasReducer';
import AtividadesPedagogicas from './AtividadesPedagogicas';
import Cantina from './Cantina';
import Diario from './DiarioReducer';
import JustificativaFalta from './JustificativaFalta';

export default (history) => combineReducers({
  router: connectRouter(history),
  settings: Settings,
  auth: Auth,
  calendario: Calendario,
  global: Global,
  modelo: Modelo,
  equipamento: Equipamento,
  cliente: Cliente,
  localControlado: LocalControlado,
  pontoAcesso: PontoAcesso,
  perfil: Perfil,
  perfilPortal: PerfilPortal,
  usuarioPlataforma: UsuarioPlataforma,
  usuarioPortal: UsuarioPortal,
  acessoPessoa: AcessoPessoa,
  acessoPerfil: AcessoPerfil,
  acessoGenero: AcessoGenero,
  acessoIdade: AcessoIdade,
  acessoPeriodo: AcessoPeriodo,
  acessoFull: AcessoFull,
  acessoBloqueio: AcessoBloqueio,
  inicio: Inicio,
  localidade: Localidade,
  vinculoPessoa: VinculoPessoa,
  unidade: Unidade,
  categoria: Categoria,
  titularidade: Titularidade,
  ambiente: Ambiente,
  portariaInicio: PortariaInicio,
  portaria: Portaria,
  escola: Escola,
  aluno: Aluno,
  curso: Curso,
  serie: Serie,
  disciplina: Disciplina,
  turma: Turma,
  matricula: Matricula,
  rematricula: Rematricula,
  anoLetivo: AnoLetivo,
  sequenciaEnturmacao: SequenciaEnturmacao,
  seriesEscola: SeriesEscola,
  componentesSerie: ComponentesSerie,
  areaConhecimento: AreaConhecimento,
  regrasAvaliacao: RegrasAvaliacao,
  notificacao: Notificacao,
  enquetes: Enquetes,
  recuperaSenha: RecuperarSenhaApp,
  notasFaltas: NotasFaltas,
  atividadesPedagogicas: AtividadesPedagogicas,
  cantina: Cantina,
  diario: Diario,
  justificativaFalta: JustificativaFalta
});
